import { connect } from 'react-redux';
import * as resumeActions from 'redux-modules/resume/actions.js';
import * as resumeSelectors from 'redux-modules/resume/selectors.js';
import Editor from './Editor';

function mapStateToProps(state) {
  return {
    languages: resumeSelectors.selectLanguageProficiencies(state),
    syncErrors: resumeSelectors.selectSyncError(state),
    syncing: resumeSelectors.selectSyncState(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSave: (data, failCallback) => dispatch(resumeActions.saveLanguages(data, failCallback))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Editor);
